module.exports = __webpack_public_path__ + "img/collaboration-fr-ca.0d356ac0.jpg";